import React, { useEffect } from "react";
import Swiper from "swiper/bundle";
import "swiper/css/bundle";
import { Link } from "react-router-dom";

const HomePage = () => {
  useEffect(() => {
    const swiper = new Swiper(".services-slider", {
      slidesPerView: 4,
      spaceBetween: 0,
      loop: true,
      speed: 1000,
      freeMode: true,
      autoplay: {
        delay: 2000,
      },
      navigation: {
        nextEl: ".services-swiper-button-next",
        prevEl: ".services-swiper-button-prev",
      },
      breakpoints: {
        10: {
          slidesPerView: 1,
        },
        575: {
          slidesPerView: 1,
        },

        768: {
          slidesPerView: 2,
        },

        992: {
          slidesPerView: 3,
        },
        1200: {
          slidesPerView: 4,
        },
      },
    });

    return () => swiper.destroy(true, true); // cleanup
  }, []);
  useEffect(() => {
    const swiper = new Swiper(".h3-testimonial-slider", {
      slidesPerView: 1,
      spaceBetween: 15,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: { slidesPerView: 1, spaceBetween: 30 },
        992: { slidesPerView: 1, spaceBetween: 30 },
      },
    });

    return () => swiper.destroy(true, true); // cleanup
  }, []);

  return (
    <main>
      {/* ======= Hero =======*/}
      <section className="hero__v6 section max-md:!pt-[8rem]" id="home">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <div className="row">
                <div className="col-lg-11">
                  <span
                    className="hero-subtitle text-uppercase"
                    data-aos="fade-up"
                    data-aos-delay={0}
                  >
                    Innovative OPD Solutions
                  </span>
                  <h1
                    className="hero-title mb-3"
                    data-aos="fade-up"
                    data-aos-delay={100}
                  >
                    Your Wellness. Your Peace of Mind. Covered.
                  </h1>
                  <p
                    className="hero-description mb-4 mb-lg-5"
                    data-aos="fade-up"
                    data-aos-delay={200}
                  >
                    Get instant access to OPD care, doctor consultations, diagnostics, and preventive wellness plans — designed to keep you healthy and worry-free.
                  </p>
                  
                  <div
                    className="cta d-flex gap-2 my-4 mb-lg-5"
                    data-aos="fade-up"
                    data-aos-delay={300}
                  >
                    <Link className="btn" to="/plans">
                      Get Started Now
                    </Link>
                  </div>
                  <div
                    className="logos mb-4"
                    data-aos="fade-up"
                    data-aos-delay={400}
                  >
                    <span className="logos-title text-uppercase mb-4 d-block">
                      Trusted by major companies worldwide
                    </span>
                    <div className="logos-images d-flex gap-4 align-items-center">
                      <img
                        className="img-fluid js-img-to-inline-svg"
                        src="assets/images/logo/actual-size/agilus.png"
                        alt="Company 1"
                        style={{ width: 110 }}
                      />
                      <img
                        className="img-fluid js-img-to-inline-svg"
                        src="assets/images/logo/actual-size/orange.png"
                        alt="Company 2"
                        style={{ width: 80 }}
                      />
                      <img
                        className="img-fluid js-img-to-inline-svg"
                        src="assets/images/logo/actual-size/thyrocare.png"
                        alt="Company 3"
                        style={{ width: 110 }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="hero-img">
                <img
                  className="img-card img-fluid max-md:!bottom-[-150px]"
                  src="assets/images/hero-2.png"
                  alt=""
                  data-aos="fade-down"
                  data-aos-delay={600}
                />
                <img
                  className="img-main img-fluid rounded-4"
                  src="assets/images/image-20.png"
                  alt=""
                  data-aos="fade-in"
                  data-aos-delay={500}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* End Hero*/}

      {/* ======= About =======*/}
      <section className="about__v4 section" id="about">
        <div className="container">
          <div className="row">
            <div className="col-md-6 order-md-2">
              <div className="row justify-content-end">
                <div className="col-md-11 mb-4 mb-md-0">
                  <span
                    className="subtitle text-uppercase mb-3"
                    data-aos="fade-up"
                    data-aos-delay={0}
                  >
                    About us
                  </span>
                  <h2 className="mb-4 text-[32px]" data-aos="fade-up" data-aos-delay={100}>
                    Reliable OPD and Preventive Wellness Solutions for Every Family
                  </h2>
                  <div data-aos="fade-up" data-aos-delay={200}>
                    <p className="mb-[16px]">
                      We believe healthcare shouldn’t begin only when something goes wrong. With our curated outpatient and wellness programs, customers get the care they need — at the right time, with the right experts, at the right price.
                    </p>
                    <p className="mb-[16px]">
                      Whether it’s routine doctor visits, checkups, diagnostics, or holistic wellness, Veda Healthcure ensures smarter, stress-free healthcare access.
                    </p>
                  </div>
                  <h4
                    className="small fw-bold mt-4 mb-3"
                    data-aos="fade-up"
                    data-aos-delay={300}
                  >
                    Key Values and Vision
                  </h4>
                  <ul
                    className="d-flex flex-row flex-wrap list-unstyled gap-3 features"
                    data-aos="fade-up"
                    data-aos-delay={400}
                  >
                    <li className="d-flex align-items-center gap-2">
                      <span className="icon rounded-circle text-center">
                        <i className="bi bi-check" />
                      </span>
                      <span className="text">Trust</span>
                    </li>
                    <li className="d-flex align-items-center gap-2">
                      <span className="icon rounded-circle text-center">
                        <i className="bi bi-check" />
                      </span>
                      <span className="text">Transparency</span>
                    </li>
                    <li className="d-flex align-items-center gap-2">
                      <span className="icon rounded-circle text-center">
                        <i className="bi bi-check" />
                      </span>
                      <span className="text">Customer-Centric Care </span>
                    </li>
                    <li className="d-flex align-items-center gap-2">
                      <span className="icon rounded-circle text-center">
                        <i className="bi bi-check" />
                      </span>
                      <span className="text">Quality Network</span>
                    </li>
                    <li className="d-flex align-items-center gap-2">
                      <span className="icon rounded-circle text-center">
                        <i className="bi bi-check" />
                      </span>
                      <span className="text">Preventive First Approach</span>
                    </li>
                  </ul>

                  <div className="mt24">
                    <Link className="btn" to="/plans">
                      Explore Plans
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="img-wrap position-relative">
                <img
                  className="img-fluid rounded-4"
                  src="assets/images/about_2-min.jpg"
                  alt=""
                  data-aos="fade-up"
                  data-aos-delay={0}
                />
                <div
                  className="mission-statement p-4 rounded-4 d-flex gap-4"
                  data-aos="fade-up"
                  data-aos-delay={100}
                >
                  <div className="mission-icon text-center rounded-circle">
                    <i className="bi bi-lightbulb fs-4" />
                  </div>
                  <div>
                    <h3 className="text-uppercase fw-bold mb-1">Mission Statement</h3>
                    <p className="fs-5 mb-0">
                      To make OPD and wellness care simple, transparent, and affordable for every family.
                      So everyone can take charge of their health with confidence.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* End About*/}

      {/* ======= Features =======*/}
      <section className="section features__v2" id="features">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div
                className="d-lg-flex p-5 rounded-4 content"
                data-aos="fade-in"
                data-aos-delay={0}
              >
                <div className="row">
                  <div
                    className="col-lg-5 mb-5 mb-lg-0"
                    data-aos="fade-up"
                    data-aos-delay={0}
                  >
                    <div className="row">
                      <div className="col-lg-11">
                        <div className="h-100 flex-column justify-content-between d-flex">
                          <div>
                            <h2 className="mb-4 text-[32px]">Why Choose us</h2>
                            <p className="mb-5">
                              Veda Healthcure gives customers more than a health plan — we offer peace of mind.
                              We simplify everyday healthcare with affordable OPD and wellness benefits.
                              We ensure quick access to doctors, diagnostics, and preventive care.
                              We help families stay healthy, stress-free, and financially protected.
                            </p>
                          </div>
                          <div className="align-self-start">
                            <Link
                              className="glightbox btn btn-play d-inline-flex align-items-center gap-2"
                              to="/plans"
                            >Explore Plans
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-7">
                    <div className="row justify-content-end">
                      <div className="col-lg-11">
                        <div className="row gap-y-[20px]">
                          <div
                            className="col-sm-6"
                            data-aos="fade-up"
                            data-aos-delay={0}
                          >
                            <div className="icon text-center mb-4">
                              <i className="bi bi-person-check fs-4" />
                            </div>
                            <h3 className="fs-6 fw-bold mb-1">
                              Affordable OPD plans
                            </h3>
                            <p>
                              Smart, cost-effective plans designed to fit every budget.
                            </p>
                          </div>
                          <div
                            className="col-sm-6"
                            data-aos="fade-up"
                            data-aos-delay={100}
                          >
                            <div className="icon text-center mb-4">
                              <i className="bi bi-graph-up fs-4" />
                            </div>
                            <h3 className="fs-6 fw-bold mb-1">
                              Cashless benefits
                            </h3>
                            <p>
                              Enjoy seamless, cashless visits at our partner clinics.
                            </p>
                          </div>
                          <div
                            className="col-sm-6"
                            data-aos="fade-up"
                            data-aos-delay={200}
                          >
                            <div className="icon text-center mb-4">
                              <i className="bi bi-headset fs-4" />
                            </div>
                            <h3 className="fs-6 fw-bold mb-1">Customer Support</h3>
                            <p>
                              Experience smooth scheduling with dependable support.
                            </p>
                          </div>
                          <div
                            className="col-sm-6"
                            data-aos="fade-up"
                            data-aos-delay={300}
                          >
                            <div className="icon text-center mb-4">
                              <i className="bi bi-shield-lock fs-4" />
                            </div>
                            <h3 className="fs-6 fw-bold mb-1">Digital health records</h3>
                            <p>
                              Keep all reports organized with smart digital records and alerts.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* End Features*/}



      {/* ======= How it works =======*/}
      <section className="section howitworks__v1" id="how-it-works">
        <div className="container">
          <div className="row mb-5">
            <div className="col-md-6 text-center mx-auto">
              <span
                className="subtitle text-uppercase mb-3"
                data-aos="fade-up"
                data-aos-delay={0}
              >
                How it works
              </span>
              <h2 className="text-[32px] mb-3" data-aos="fade-up" data-aos-delay={100}>
                How It Works
              </h2>
              <p className="m" data-aos="fade-up" data-aos-delay={200}>
                Get easy, cashless healthcare with Veda Healthcure—pick a plan, book quickly, and track everything digitally.
              </p>
            </div>
          </div>
          <div className="row g-md-5">
            <div className="col-md-6 col-lg-3">
              <div
                className="step-card text-center h-100 d-flex flex-column justify-content-start position-relative"
                data-aos="fade-up"
                data-aos-delay={0}
              >
                <div data-aos="fade-right" data-aos-delay={500}>
                  <img
                    className="arch-line"
                    src="assets/images/arch-line.svg"
                    alt=""
                  />
                </div>
                <span className="step-number rounded-circle text-center fw-bold mb-5 mx-auto">
                  1
                </span>
                <div>
                  <h3 className="fs-5 mb-4">Choose a plan</h3>
                  <p>
                    Pick the OPD or wellness plan that suits you.
                  </p>
                </div>
              </div>
            </div>
            <div
              className="col-md-6 col-lg-3"
              data-aos="fade-up"
              data-aos-delay={600}
            >
              <div className="step-card reverse text-center h-100 d-flex flex-column justify-content-start position-relative">
                <div data-aos="fade-right" data-aos-delay={1100}>
                  <img
                    className="arch-line reverse"
                    src="assets/images/arch-line-reverse.svg"
                    alt=""
                  />
                </div>
                <span className="step-number rounded-circle text-center fw-bold mb-5 mx-auto">
                  2
                </span>
                <h3 className="fs-5 mb-4">Activate Instantly</h3>
                <p>
                  Get quick access to our nationwide network.
                </p>
              </div>
            </div>
            <div
              className="col-md-6 col-lg-3"
              data-aos="fade-up"
              data-aos-delay={1200}
            >
              <div className="step-card text-center h-100 d-flex flex-column justify-content-start position-relative">
                <div data-aos="fade-right" data-aos-delay={1700}>
                  <img
                    className="arch-line"
                    src="assets/images/arch-line.svg"
                    alt=""
                  />
                </div>
                <span className="step-number rounded-circle text-center fw-bold mb-5 mx-auto">
                  3
                </span>
                <h3 className="fs-5 mb-4">Book Your Visit</h3>
                <p>
                  Schedule consultations or tests in minutes.
                </p>
              </div>
            </div>
            <div
              className="col-md-6 col-lg-3"
              data-aos="fade-up"
              data-aos-delay={1800}
            >
              <div className="step-card last text-center h-100 d-flex flex-column justify-content-start position-relative">
                <span className="step-number rounded-circle text-center fw-bold mb-5 mx-auto">
                  4
                </span>
                <div>
                  <h3 className="fs-5 mb-4">Go Cashless</h3>
                  <p>
                    Enjoy smooth, cashless OPD & wellness services.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* End How it works*/}

      {/* ======= Stats =======*/}
      <section className="stats__v3 section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div
                className="d-flex flex-wrap content rounded-4"
                data-aos="fade-up"
                data-aos-delay={0}
              >
                <div className="rounded-borders">
                  <div className="rounded-border-1" />
                  <div className="rounded-border-2" />
                  <div className="rounded-border-3" />
                </div>
                <div
                  className="col-12 col-sm-6 col-md-4 mb-4 mb-md-0 text-center"
                  data-aos="fade-up"
                  data-aos-delay={100}
                >
                  <div className="stat-item">
                    <h3 className="fs-1 fw-bold">
                      <span
                        className="purecounter"
                        data-purecounter-start={0}
                        data-purecounter-end={10}
                        data-purecounter-duration={2}
                      >
                        1000
                      </span>
                      <span>+</span>
                    </h3>
                    <p className="mb-0">Customer Satisfaction</p>
                  </div>
                </div>
                <div
                  className="col-12 col-sm-6 col-md-4 mb-4 mb-md-0 text-center"
                  data-aos="fade-up"
                  data-aos-delay={200}
                >
                  <div className="stat-item">
                    <h3 className="fs-1 fw-bold">
                      {" "}
                      <span
                        className="purecounter"
                        data-purecounter-start={0}
                        data-purecounter-end={200}
                        data-purecounter-duration={2}
                      >
                        1400
                      </span>
                      <span>+</span>
                    </h3>
                    <p className="mb-0">Appointment Booked</p>
                  </div>
                </div>
                <div
                  className="col-12 col-sm-6 col-md-4 mb-4 mb-md-0 text-center"
                  data-aos="fade-up"
                  data-aos-delay={300}
                >
                  <div className="stat-item">
                    <h3 className="fs-1 fw-bold">
                      <span
                        className="purecounter"
                        data-purecounter-start={0}
                        data-purecounter-end={20}
                        data-purecounter-duration={2}
                      >
                        300
                      </span>
                      <span>+</span>
                    </h3>
                    <p className="mb-0">Expert Specialists</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* End Stats*/}

      {/* ======= Testimonials =======*/}
      {/* <section className="section testimonials__v2" id="testimonials">
        <div className="container">
          <div className="row mb-5">
            <div className="col-lg-5 mx-auto text-center">
              <span
                className="subtitle text-uppercase mb-3"
                data-aos="fade-up"
                data-aos-delay={0}
              >
                Testimonials
              </span>
              <h2 className="mb-3" data-aos="fade-up" data-aos-delay={100}>
                What Our Users Are Saying
              </h2>
              <p data-aos="fade-up" data-aos-delay={200}>
                Real Stories of Success and Satisfaction from Our Diverse Community
              </p>
            </div>
          </div>
          <div className="row g-4" data-masonry='{"percentPosition": true }'>
            <div className="col-md-6 col-lg-4" data-aos="fade-up" data-aos-delay={0}>
              <div className="testimonial rounded-4 p-4">
                <blockquote className="mb-3">
                  “ Their wellness program helped me track my health and stay consistent. Great value for money! ”
                </blockquote>
                <div className="testimonial-author d-flex gap-3 align-items-center">
                  <div className="author-img">
                    <img
                      className="rounded-circle img-fluid w-[50px] h-[50px] object-cover object-top"
                      src="assets/images/c2.jpg"
                      alt=""
                    />
                  </div>
                  <div className="lh-base">
                    <strong className="d-block">Neha Sharma</strong>
                    <span>Pune</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4" data-aos="fade-up" data-aos-delay={100}>
              <div className="testimonial rounded-4 p-4">
                <blockquote className="mb-3">
                  “ Veda Healthcure made routine doctor visits so affordable. The cashless OPD feature is a game changer! ”
                </blockquote>
                <div className="testimonial-author d-flex gap-3 align-items-center">
                  <div className="author-img">
                    <img
                      className="rounded-circle img-fluid w-[50px] h-[50px] object-cover"
                      src="assets/images/c1.jpg"
                      alt=""
                    />
                  </div>
                  <div className="lh-base">
                    <strong className="d-block">Rohan Mishra</strong>
                    <span>Mumbai</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4" data-aos="fade-up" data-aos-delay={100}>
              <div className="testimonial rounded-4 p-4">
                <blockquote className="mb-3">
                  “ Excellent customer support and a very practical health plan for families and individuals. ”
                </blockquote>
                <div className="testimonial-author d-flex gap-3 align-items-center">
                  <div className="author-img">
                    <img
                      className="rounded-circle img-fluid w-[50px] h-[50px] object-cover"
                      src="assets/images/c3.jpg"
                      alt=""
                    />
                  </div>
                  <div className="lh-base">
                    <strong className="d-block">Amrita Rana</strong>
                    <span>Delhi</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      {/* Testimonials*/}


    </main>
  );
};

export default HomePage;
